import { useCallback, useContext, useLayoutEffect } from 'react'
import { FormContext } from '../FormProvider'
import { FormFieldProps, FormRadioGroupType } from './type'
import { RadioGroup, RadioGroupItem } from '@/components/ui/radio-group'
import { Label } from '@/components/ui/label'
import { RadioOption } from '../type'

export const FormRadioGroupField = ({
  data,
  field,
}: FormFieldProps<FormRadioGroupType>) => {
  const context = useContext(FormContext)

  const itemId = useCallback(
    (option: RadioOption) => {
      return `radio-group-item-${data.key}-${option.value}`
    },
    [data.key],
  )
  return (
    <RadioGroup
      className="flex flex-row gap-4 py-2"
      value={field.value}
      onValueChange={field.onChange}
    >
      {data.options.map((option) => {
        const id = itemId(option)

        return (
          <div key={id} className="flex cursor-pointer gap-1.5">
            <RadioGroupItem id={id} value={option.value} />
            <Label className="text-[13px] font-normal" htmlFor={id}>
              {option.label || option.value}
            </Label>
          </div>
        )
      })}
    </RadioGroup>
  )
}
